import dev_config from './config.development';
import prod_config from './config.production';


export default process.env.REACT_APP_HOST_ENV === "production"? prod_config : dev_config;